// extracted by mini-css-extract-plugin
export var alt = "MobileGlobalSearchSummary-module--alt--79cc2";
export var container = "MobileGlobalSearchSummary-module--container--6c62a";
export var desktopOnly = "MobileGlobalSearchSummary-module--desktopOnly--41d8d";
export var location = "MobileGlobalSearchSummary-module--location--a9c50";
export var main = "MobileGlobalSearchSummary-module--main--c2c31";
export var mobileInputWrapper = "MobileGlobalSearchSummary-module--mobileInputWrapper--452ee";
export var mobileOnly = "MobileGlobalSearchSummary-module--mobileOnly--c0f0d";
export var primaryButton = "MobileGlobalSearchSummary-module--primaryButton--eed31";
export var textLeft = "MobileGlobalSearchSummary-module--textLeft--31564";
export var visuallyHidden = "MobileGlobalSearchSummary-module--visuallyHidden--ac014";